import React, {useState} from "react";
import { Trash, Search } from "react-bootstrap-icons";

const List = ({
    items,
    onSelect,
    onRemove
}) => {

    const remove = false;
    
    return (
        <ul className="list-group list-group-flush w-100">
            {items.map(item => (
                <li
                    key={item.uid}
                    className="list-group-item w-100 p-1"
                    style={{ cursor: "pointer", display: 'flex', alignItems: 'stretch' }}
                >
                    <div
                        className="d-flex align-items-center"
                        style={{ marginRight: "5px" }}
                    >
                        <div className="form-check">
                            <input
                                type="checkbox"
                                id={`checkbox-${item.uid}`}
                                className="form-check-input"
                                checked={item.selected}
                                onChange={() => onSelect(item.uid)}
                                style={{ width: '20px', height: '20px' }}
                            />
                        </div>
                    </div>

                    <div style={{ flex: 1, padding: '4px' }}>
                        <div className="d-flex align-items-center">
                            <span className="flex-grow-1">{item.name}</span>

                            {remove && (<button
                                type="button"
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => onRemove('tag', item.uid)}
                            >
                                <Trash size={16} />
                            </button>)}
                        </div>
                    </div>
                </li>
            ))}
        </ul>  
    );
};

export default List;